// SVG icon paths
export const icons = {
  activeJobs: `${process.env['PUBLIC_URL'] || ''}/images/active-jobs.svg`,
  activeJobsTransparent: `${process.env['PUBLIC_URL'] || ''}/images/active-jobs-transparent.svg`,
  failedJobs: `${process.env['PUBLIC_URL'] || ''}/images/failed-jobs.svg`,
  failedJobsTransparent: `${process.env['PUBLIC_URL'] || ''}/images/failed-jobs-transparent.svg`,
  failureRate: `${process.env['PUBLIC_URL'] || ''}/images/failure-rate.svg`,
  failureRateTransparent: `${process.env['PUBLIC_URL'] || ''}/images/failure-rate-transparent.svg`,
  jobDuration: `${process.env['PUBLIC_URL'] || ''}/images/average-job-duration.svg`,
  jobDurationTransparent: `${process.env['PUBLIC_URL'] || ''}/images/average-job-duration-transparent.svg`,
  resourceUtilization: `${process.env['PUBLIC_URL'] || ''}/images/resource-utilization.svg`,
  resourceUtilizationTransparent: `${process.env['PUBLIC_URL'] || ''}/images/resource-utilization-transparent.svg`,
  cpuCores: `${process.env['PUBLIC_URL'] || ''}/images/average-cpu-cores.svg`,
  cpuCoresTransparent: `${process.env['PUBLIC_URL'] || ''}/images/average-cpu-cores-transparent.svg`,
  arrowTopRight: `${process.env['PUBLIC_URL'] || ''}/images/arrow-top-right.svg`,
  arrowTopRightTransparent: `${process.env['PUBLIC_URL'] || ''}/images/arrow-top-right-transparent.svg`,
};

// Metric cards data
export const mainMetrics = [
  {
    title: "Total Jobs",
    subtitle: "Flarion Enabled",
    titleValue: 1248,
    subtitleValue: 845,
    smallBoxValue: 65,
    smallBoxSuffix: '%',
    fill: "yellowFlarion",
    icon: 'arrowTopRight'
  },
  {
    title: "Annual Potential Savings",
    titlePrefix: "$",
    titleValue: 12800000,
    fill: "white",
    icon: 'arrowTopRight'
  },
  {
    title: "Compute Time Reduction",
    subtitle: "Resource Savings",
    titleValue: 55,
    titleSuffix: '%',
    fill: "white",
    smallBoxValue: 45,
    smallBoxSuffix: '%',
    icon: 'arrowTopRight'
  },
  {
    title: "Flarion Savings",
    subtitle: "Annualized Savings",
    titleValue: 302000,
    titlePrefix: "$",
    fill: "white",
    smallBoxValue: 1530000,
    smallBoxPrefix: "$",
    icon: 'arrowTopRight'
  }
];

export const smallMetrics = [
  {
    title: "Active Jobs",
    titleValue: 92,
    fill: "white",
    icon: 'activeJobs'
  },
  {
    title: "Failed Jobs",
    titleValue: 284,
    fill: "white",
    icon: 'failedJobs'
  },
  {
    title: "Failure Rate",
    titleValue: 6.1,
    titleSuffix: "%",
    fill: "white",
    icon: 'failureRate'
  },
  {
    title: "Avg. Job Duration",
    titleValue: 18.5,
    titleSuffix: "m",
    fill: "white",
    icon: 'jobDuration'
  },
  {
    title: "Resource Utilization",
    titleValue: 78,
    titleSuffix: "%",
    fill: "white",
    icon: 'resourceUtilization'
  },
  {
    title: "Avg. CPU Cores/Job",
    titleValue: 18,
    fill: "white",
    icon: 'cpuCores'
  }
];

// Generate mock resource utilization data
export const resourceUtilizationData = Array.from({ length: 31 }, (_, i) => {
  const day = 31 - i;
  return {
    day,
    flarionCPU: Math.floor(40 + Math.random() * 30),
    sparkCPU: Math.floor(60 + Math.random() * 25),
    flarionMemory: Math.floor(30 + Math.random() * 35),
    sparkMemory: Math.floor(50 + Math.random() * 30)
  };
}).reverse();

export const resourceUtilizationSeries = [
  { dataKey: 'flarionCPU', label: 'Flarion CPU' },
  { dataKey: 'sparkCPU', label: 'Spark CPU' },
  { dataKey: 'flarionMemory', label: 'Flarion Memory' },
  { dataKey: 'sparkMemory', label: 'Spark Memory' }
];

// Generate mock error data
export const errorData = Array.from({ length: 30 }, (_, i) => ({
  day: i + 1,
  OutOfMemoryError: Math.random() * 30,
  JobAbortedStageFailure: Math.random() * 10,
  shuffleFetchFailedException: Math.random() * 8,
  NotSerializableException: Math.random() * 11,
  OtherError: Math.random() * 10,
}));

export const errorSeries = [
  { dataKey: 'OutOfMemoryError', label: 'OutOfMemoryError' },
  { dataKey: 'JobAbortedStageFailure', label: 'Job aborted: Stage Failure' },
  { dataKey: 'shuffleFetchFailedException', label: 'shuffle.FetchFailedException' },
  { dataKey: 'NotSerializableException', label: 'NotSerializableException' },
  { dataKey: 'OtherError', label: 'Other Error' }
];

// Savings opportunities data
export const savingsOpportunities = [
  {
    jobName: "Daily Data Processing Pipeline",
    jobId: "SPARK-45872",
    currentCost: 25000,
    potentialSavings: 14500,
  },
  {
    jobName: "Customer Analytics ETL",
    jobId: "ETL-28394",
    currentCost: 56000,
    potentialSavings: 21000,
  },
  {
    jobName: "ML Model Training Pipeline",
    jobId: "ML-TRAIN-7821",
    currentCost: 36400,
    potentialSavings: 23200,
  },
  {
    jobName: "Data Warehouse Integration",
    jobId: "HADOOP-9283",
    currentCost: 64800,
    potentialSavings: 32700,
  },
  {
    jobName: "Batch Processing Jobs",
    jobId: "BATCH-3672",
    currentCost: 17400,
    potentialSavings: 8700,
  },
  {
    jobName: "Data Pipeline Job",
    jobId: "DATA-PIPELINE-1234",
    currentCost: 12000,
    potentialSavings: 10000,
  }
];

// Pie chart data
export const pieChartData = {
  jobStatus: [
    { label: 'Completed', percentage: 65 },
    { label: 'Running', percentage: 13.4 },
    { label: 'Failed', percentage: 9.2 },
    { label: 'Pending', percentage: 7.3 },
    { label: 'Canceled', percentage: 1.9 }
  ],
  jobCost: [
    { label: '<$1k', percentage: 36 },
    { label: '$1k-$5k', percentage: 27 },
    { label: '$5k-$20k', percentage: 20 },
    { label: '>$20k', percentage: 17 }
  ],
  jobDuration: [
    { label: '<10m>', percentage: 32 },
    { label: '10m-30m', percentage: 45 },
    { label: '30m-2h', percentage: 18 },
    { label: '>2h', percentage: 5 }
  ]
};